module.exports = __webpack_public_path__ + "img/sankaku_84_red.2121233f.png";